import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql, Link } from "gatsby"
import { css } from "@emotion/core"
import { rhythm } from "../utils/typography"
import SEO from './seo'

import BackgroundImage from 'gatsby-background-image'

function StyledLink(to, text) {
  return (
    <Link
      css={css`
        padding-right: 10px;
      `}
      activeClassName='selected' exact to={to}
    >
      {text}
    </Link>
  )
}

const Header = ({ siteTitle }) => (
  <header
    css={css`
    `}
  >
      <div
        css = {css`
          text-align: center;
          background-color: lavenderblush;
        `}
      >
        {StyledLink('/', 'Home')}
        {StyledLink('/blog', 'Blog')}
      </div>
  </header>
)

const Footer = () => (
  <footer className='footer'
    css = {css`
      flex-shrink: 0;
      background-color: #301934;
      color: #FFF;
      text-align: center;
    `}
  >
    <p>
      btc: 35Mm4gWLX4Fs5DxS21rKMsp7bozoyUQVVa
    </p>
    © {new Date().getFullYear()}, Built with
    {` `}
    <a href="https://www.gatsbyjs.org">Gatsby</a>
  </footer>
)


const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
      desktop: file(relativePath: { eq: "roman-4254.png" }) {
        childImageSharp {
          fluid(quality: 100, maxHeight: 1080, maxWidth: 1920) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)
  const imageData = data.desktop.childImageSharp.fluid
  const title = data.site.siteMetadata.title
  console.log('layout re render')
  return (
    <div
      id='root'
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <SEO title={title}/>
      <Header siteTitle={title} />
        <BackgroundImage
          Tag="section"
          fluid={imageData}
          backgroundColor={`#040e18`}
          css={css`
            background-repeat: no-repeat;
            background-size: cover;
            flex-grow: 1;
          `}
        >
          <main
            css={css`
              margin: 5vh auto;
              padding: 2.5vh 2.5vw;
              max-width: 80vw;
              background-color: white;
              border-radius: 10px 10px 10px 10px;
              -moz-border-radius: 10px 10px 10px 10px;
              -webkit-border-radius: 10px 10px 10px 10px;
              border: 0px solid #000000;
            `}
          >
            {children}
          </main>
        </BackgroundImage>
      <Footer />
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
